import React from 'react';
import styled from 'styled-components';
import Button from 'gatsby-theme-core/src/components/button/index';
import { useNav } from '../provider';

const Backdrop = ({ className, ...props }) => {
  const { setOpen } = useNav();

  return (
    <Button
      {...props}
      aria-label="Close by overlay"
      onClick={() => setOpen(false)}
      className={className}
    />
  );
};

export default styled(Backdrop).attrs({
  wrapper: true,
  nav: true,
  navType: 'content',
  eventAction: 'close',
})`
  background-color: rgba(44, 50, 62, 0.5);
  display: block;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 3;
  width: 100vw;

  @media all and (max-width: ${({ theme }) => theme.breakingpoints.sm}) {
    display: none;
  }
`;
